import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectCustomerData } from 'Core/redux/customer/selectors';
import {
  selectFilteredFutureActions,
  selectFutureActionsFilterVisible,
  selectFutureActionsLoading,
  selectfetchFutureActionsLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { editFutureActionData } from './store/slice';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useTransformOptions } from '../../core/hooks';
import { PartService } from '../../service/api/part-service';

const { FUTUREACTIONS_ADD_EDIT, FUTUREACTIONS_DETAILS } = MODAL_TYPES;

const FutureActionsTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const [partsList, setPartsList] = useState([]);
  const futureActionsTileRef = useRef(null);

  const filteredFutureActions = useSelector(selectFilteredFutureActions);
  const isLoading = useSelector(selectFutureActionsLoading);
  const filterVisible = useSelector(selectFutureActionsFilterVisible);
  const isFetchDataLoading = useSelector(selectfetchFutureActionsLoading);
  const headerVisible = useSelector(isHeaderVisible);

  // Debug logging
  console.log('🔍 Future Actions Tile - filteredFutureActions:', filteredFutureActions);
  console.log('🔍 Future Actions Tile - isLoading:', isLoading);
  console.log('🔍 Future Actions Tile - isFetchDataLoading:', isFetchDataLoading);

  const updateColumnSettings = useCallback(() => {
    if (futureActionsTileRef.current) {
      const width = futureActionsTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

    useEffect(() => {
      const fetchParts = async () => {
        try {
          const response = await PartService.getAllPartsList();
          if (response?.response) {
            setPartsList(response.response);
          }
        } catch (error) {
          console.error('Error fetching parts list:', error);
        }
      };
  
      fetchParts();
    }, []);

  const Tile = ({ futureAction }) => {
  const dispatch = useDispatch();
  const customers = useSelector(selectCustomerData);
  const customerOptions = useTransformOptions(customers, 'id', 'customerName', '');
  const part = partsList.find(p => p.id === futureAction.partID);
  const partNumber = part?.partNumber || '';
  
  // Map API response fields to tile display
  const toolID = futureAction.toolID || futureAction.id || 'N/A';
  const description = futureAction.moldDescription || futureAction.description || futureAction.title || 'No description';
  const companyName = futureAction.customerName || futureAction.companyName || futureAction.manufacturer || 'Unknown Company';
  
  const handleEdit = e => {
    e.stopPropagation();
    console.log('🔧 Edit button clicked for:', futureAction);
    console.log('🔧 Modal type:', FUTUREACTIONS_DETAILS);
    
    const modalData = {
      ...futureAction,
      moldInfoID: futureAction.moldInfoID || futureAction.id || 1
    };
    
    console.log('🔧 Modal data:', modalData);
    
    dispatch(showModal(FUTUREACTIONS_DETAILS, modalData));
    
    console.log('🔧 Modal dispatch completed');
  };

        return (
          <div key={futureAction.toolID || Math.random()} className="tile">
            <div
              className={`card p-3 m-2 ${futureAction.isNewlyCreated ? 'border-success' : ''}`}
              style={{
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              }}
            >
              <div className="tile-actions">
                <ButtonGroup size="sm">
                  <Button variant="light" onClick={handleEdit}>
                    <Edit size={16} />
                  </Button>
                </ButtonGroup>
              </div>
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-row align-items-center">
                  <div className="ms-2 c-details">
                    <h6 className="mb-0">{toolID}</h6>
                    <span>{description}</span>
                  </div>
                </div>
              </div>
              <div className="mt-1">
                <span
                  className="badge"
                  style={{
                    backgroundColor: futureAction.backgroundColor || '#e0e0e0',
                    color: futureAction.textColor || '#000000',
                  }}
                >
                  {partNumber || 'N/A'}
                </span>
              </div>
              <div className="mt-2 tile-descriptionText text-truncate w-85">
                <h5 className="tile-description">{companyName}</h5>
              </div>
            </div>
          </div>
        );
};
 const itemData = filteredFutureActions.map(futureAction => (
    <Tile futureAction={futureAction} />
  ));
  return (
    <div
      className={`tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={futureActionsTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredFutureActions.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};
const MySwal = withReactContent(Swal);

export default FutureActionsTile;
